import { createFileRoute } from '@tanstack/react-router';

import { useAuth } from '@features/auth/hooks/useAuth';
import { TournamentListPage } from '@features/club/pages/TournamentListPage';
import { PromoNavigationWidget } from '@features/club/ui/PromoNavigation/PromoNavigationWidget';
import { TournamentsListWidget } from '@features/club/ui/TournamentsList/TournamentsListWidget';
import { SiteLayoutWidget } from '@features/shared/ui/SiteLayout/SiteLayoutWidget';

import { DEFAULT_CLUB_ID } from '../club';

export const Route = createFileRoute('/tournament/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { user } = useAuth();
  const userClubs = user && Object.keys(user.clubs);
  const clubId = userClubs?.[0] || DEFAULT_CLUB_ID;

  return (
    <SiteLayoutWidget
      clubId={clubId}
      hideCreateTournament
      preset="default-full-width"
      backgroundPreset="coloured-promo-gradient"
    >
      <TournamentListPage
        navigation={<PromoNavigationWidget activeTab="tournaments" />}
        allTournamentsList={<TournamentsListWidget />}
      />
    </SiteLayoutWidget>
  );
}
